module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-a-critter"
  }, [_c('h2', [_vm._v("Help expand the site")]), _vm._v(" "), _c('p', [_vm._v("We're always looking for more Creators to add to CR Market. If there is someone who  isn't on this site that you feel should be on here then please send us their Twitter handle or Website.")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "contact",
      "method": "POST",
      "netlify": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form-name",
      "value": "contact"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "form-fields"
  }, [_c('li', [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    attrs: {
      "name": "email",
      "type": "email",
      "id": "email",
      "required": ""
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message:")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "message",
      "id": "message",
      "required": ""
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-fields__controls"
  }, [_c('button', {
    staticClass: "button--submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-665126c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUs.vue
// module id = 758
// module chunks = 0